import React from 'react'
import { Route, Switch, Redirect } from 'react-router-dom'
import { ConnectedRouter } from 'connected-react-router'
import Loadable from 'react-loadable'

import Loader from 'components/LayoutComponents/Loader'
import IndexLayout from 'layouts'
import NotFoundPage from 'pages/404'

const loadable = loader =>
  Loadable({
    loader,
    delay: false,
    loading: () => <Loader />,
  })

const routes = [
  // System Pages
  {
    path: '/dashboard',
    component: loadable(() => import('pages/dental/dashboard')),
    exact: true,
  },
  {
    path: '/user/login',
    component: loadable(() => import('pages/user/login')),
    exact: true,
  },
  {
    path: '/user/forgot',
    component: loadable(() => import('pages/user/forgot')),
    exact: true,
  },

  // 病歷
  // 填寫病歷
  {
    path: '/patients-form',
    component: loadable(() => import('pages/dental/patients-form')),
    exact: true,
  },
  {
    path: '/patients',
    component: loadable(() => import('pages/dental/patients/readlist')),
    exact: true,
  },
  {
    path: '/patients/find',
    component: loadable(() => import('pages/dental/patients/find')),
    exact: true,
  },
  {
    path: '/patients/:id',
    component: loadable(() => import('pages/dental/patients/read')),
    exact: true,
  },
  {
    path: '/patients/:id/update',
    component: loadable(() => import('pages/dental/patients/update')),
    exact: true,
  },

  // 治療計劃
  {
    path: '/projs/:id',
    component: loadable(() => import('pages/dental/projs/read')),
    exact: true,
  },

  // 評價
  {
    path: '/comments',
    component: loadable(() => import('pages/dental/comments/readlist')),
    exact: true,
  },
  {
    path: '/comments/stats',
    component: loadable(() => import('pages/dental/comments/stats')),
    exact: true,
  },
  {
    path: '/comments/create',
    component: loadable(() => import('pages/dental/comments/create')),
    exact: true,
  },
  {
    path: '/comments/:id',
    component: loadable(() => import('pages/dental/comments/read')),
    exact: true,
  },
  {
    path: '/comments/:id/update',
    component: loadable(() => import('pages/dental/comments/update')),
    exact: true,
  },

  // Line預約
  {
    path: '/resvs',
    component: loadable(() => import('pages/dental/resvs/readlist')),
    exact: true,
  },

  // 診所的醫師
  {
    path: '/cdrs',
    component: loadable(() => import('pages/dental/cdrs/readlist')),
    exact: true,
  },
  {
    path: '/cdrs/create',
    component: loadable(() => import('pages/dental/cdrs/create')),
    exact: true,
  },
  {
    path: '/cdrs/:id',
    component: loadable(() => import('pages/dental/cdrs/read')),
    exact: true,
  },
  {
    path: '/cdrs/:id/update',
    component: loadable(() => import('pages/dental/cdrs/update')),
    exact: true,
  },

  // 牙材
  {
    path: '/mats',
    component: loadable(() => import('pages/dental/mats/readlist')),
    exact: true,
  },
  {
    path: '/mats/create',
    component: loadable(() => import('pages/dental/mats/create')),
    exact: true,
  },
  {
    path: '/mats/:id',
    component: loadable(() => import('pages/dental/mats/read')),
    exact: true,
  },
  {
    path: '/mats/:id/update',
    component: loadable(() => import('pages/dental/mats/update')),
    exact: true,
  },

  // 治療項目
  {
    path: '/cures',
    component: loadable(() => import('pages/dental/cures/readlist')),
    exact: true,
  },
  {
    path: '/cures/create',
    component: loadable(() => import('pages/dental/cures/create')),
    exact: true,
  },
  {
    path: '/cures/:id',
    component: loadable(() => import('pages/dental/cures/read')),
    exact: true,
  },
  {
    path: '/cures/:id/update',
    component: loadable(() => import('pages/dental/cures/update')),
    exact: true,
  },

  // 明細帳
  {
    path: '/trans/details',
    component: loadable(() => import('pages/dental/trans/details')),
    exact: true,
  },
  // 牙材耗用報表
  {
    path: '/used/details',
    component: loadable(() => import('pages/dental/used/details')),
    exact: true,
  },
  // 醫師薪資報表
  {
    path: '/trans/stat',
    component: loadable(() => import('pages/dental/trans/stat')),
    exact: true,
  },

  // divider

  // 診所
  {
    path: '/clinics',
    component: loadable(() => import('pages/dental/clinics/readlist')),
    exact: true,
  },
  {
    path: '/clinics/create',
    component: loadable(() => import('pages/dental/clinics/create')),
    exact: true,
  },
  {
    path: '/clinics/:id',
    component: loadable(() => import('pages/dental/clinics/read')),
    exact: true,
  },
  {
    path: '/clinics/:id/update',
    component: loadable(() => import('pages/dental/clinics/update')),
    exact: true,
  },

  // 醫師
  {
    path: '/doctors',
    component: loadable(() => import('pages/dental/doctors/readlist')),
    exact: true,
  },
  {
    path: '/doctors/create',
    component: loadable(() => import('pages/dental/doctors/create')),
    exact: true,
  },
  {
    path: '/doctors/:id',
    component: loadable(() => import('pages/dental/doctors/read')),
    exact: true,
  },
  {
    path: '/doctors/:id/update',
    component: loadable(() => import('pages/dental/doctors/update')),
    exact: true,
  },

  // LineChannel
  {
    path: '/chans',
    component: loadable(() => import('pages/dental/chans/readlist')),
    exact: true,
  },
  {
    path: '/chans/create',
    component: loadable(() => import('pages/dental/chans/create')),
    exact: true,
  },
  {
    path: '/chans/:id',
    component: loadable(() => import('pages/dental/chans/read')),
    exact: true,
  },
  {
    path: '/chans/:id/update',
    component: loadable(() => import('pages/dental/chans/update')),
    exact: true,
  },

  // 後台管理者
  {
    path: '/admins',
    component: loadable(() => import('pages/dental/admins/readlist')),
    exact: true,
  },
  {
    path: '/admins/create',
    component: loadable(() => import('pages/dental/admins/create')),
    exact: true,
  },
  {
    path: '/admins/:id',
    component: loadable(() => import('pages/dental/admins/read')),
    exact: true,
  },
  {
    path: '/admins/:id/update',
    component: loadable(() => import('pages/dental/admins/update')),
    exact: true,
  },

  // 參數管理
  {
    path: '/params',
    component: loadable(() => import('pages/dental/params/readlist')),
    exact: true,
  },
  {
    path: '/params/create',
    component: loadable(() => import('pages/dental/params/create')),
    exact: true,
  },
  {
    path: '/params/:id',
    component: loadable(() => import('pages/dental/params/read')),
    exact: true,
  },
  {
    path: '/params/:id/update',
    component: loadable(() => import('pages/dental/params/update')),
    exact: true,
  },
]

class Router extends React.Component {
  render() {
    const { history } = this.props
    return (
      <ConnectedRouter history={history}>
        <IndexLayout>
          <Switch>
            <Route exact path="/" render={() => <Redirect to="/dashboard" />} />
            {routes.map(route => (
              <Route
                path={route.path}
                component={route.component}
                key={route.path}
                exact={route.exact}
              />
            ))}
            <Route component={NotFoundPage} />
          </Switch>
        </IndexLayout>
      </ConnectedRouter>
    )
  }
}

export default Router
